import sortBy from 'lodash/sortBy';

import { LessonActivities_sectionsOverview } from '../__generated__/LessonActivities';
import { SectionOrSubSectionOverview } from '../activity-builder.constants';
import { StudentSectionOrSubSectionOverview } from 'approot/activity-builder/student/student.constants';

export const getActivityDetailsFromOverview = ({
  section,
  sectionsOverview,
}: {
  section: SectionOrSubSectionOverview | StudentSectionOrSubSectionOverview;
  sectionsOverview:
    | SectionOrSubSectionOverview[]
    | StudentSectionOrSubSectionOverview[]
    | null;
}): {
  activityNumber: number;
  currentStep: number;
  totalSteps: number;
  progressLabel: string;
  differentiation: number | null;
  parentSectionId: string | null;
  isCheckPoint: boolean;
} => {
  let totalSteps = 1;
  let currentStep = 1;

  const parentSectionId =
    section && 'parentSectionId' in section
      ? section.parentSectionId
      : section.id;
  const parentSection = (sectionsOverview as SectionOrSubSectionOverview[]).find(
    s => s.id === parentSectionId
  );

  const parentActivities = (sectionsOverview as SectionOrSubSectionOverview[])?.filter(
    s => !('parentSectionId' in s)
  );
  const activityNumber = parentActivities?.findIndex(
    s => s.id === parentSectionId
  );

  if (parentSection && 'subSectionsOverview' in parentSection) {
    const overviews = sortBy(parentSection.subSectionsOverview, 'sort') || [];
    const subSectionIndex = overviews.findIndex(s => s.id === section.id) || 0;
    totalSteps = overviews.length + 1;
    currentStep = subSectionIndex + 2;
  } else {
    const subSections =
      (section as LessonActivities_sectionsOverview).subSectionsOverview || [];
    totalSteps = subSections.length + 1;
  }

  return {
    activityNumber: activityNumber ? activityNumber + 1 : 1,
    currentStep,
    totalSteps,
    differentiation: parentSection
      ? parentSection.differentiation
      : section.differentiation,
    isCheckPoint: (section as SectionOrSubSectionOverview).checkPoint,
    parentSectionId,
    progressLabel: `Part ${currentStep} of ${totalSteps}`,
  };
};
